import React from "react";
import {
    Box,
    Typography,
    Card,
    CardContent,
    Container,
    useTheme,
} from "@mui/material";
import { motion } from "framer-motion";

const articles = [
    {
        title: "Trusted by Users.",
        desc: "Thousands of users trust us for managing their finances securely....",
        img: "https://ik.imagekit.io/arthgyan/Arthgyan_Web/trusted",
    },
    {
        title: "24x7 Support",
        desc: "Dedicated customer support round the clock for your needs....",
        img: "https://ik.imagekit.io/arthgyan/Arthgyan_Web/24*7",
    },
    {
        title: "Secure & Reliable",
        desc: "We ensure data privacy and use bank-level encryption....",
        img: "https://ik.imagekit.io/arthgyan/Arthgyan_Web/secure",
    },
];

const WhyUs = () => {
    const theme = useTheme();
    const MotionCard = motion(Card);

    return (
        <Box sx={{ py: { xs: 5, md: 4 } }}>
            <Container maxWidth="lg">

                {/* HEADER */}
                <Box sx={{ mb: { xs: 3, md: 4 } }}>
                    <Typography
                        sx={{
                            fontSize: "13px",
                            letterSpacing: "1.5px",
                            fontWeight: 600,
                            mb: 1,
                            color: theme.palette.primary.main,
                        }}
                        data-aos="fade-right"
                    >
                        • OUR EDGE
                    </Typography>


                    <Typography
                        sx={{
                            fontSize: { xs: "20px", sm: "28px", md: "40px" },
                            fontWeight: 600,
                            color: theme.palette.text.primary,
                            position: "relative",
                            display: "inline-block",
                        }}
                    >
                        What Makes{" "}
                        <Box
                            component="span"
                            sx={{
                                fontWeight: 900,
                                background: `linear-gradient(90deg, ${theme.palette.primary.main}, ${theme.palette.text.primary})`,
                                WebkitBackgroundClip: "text",
                                WebkitTextFillColor: "transparent",
                                position: "relative",
                                display: "inline-block",
                                "&::after": {
                                    content: '""',
                                    position: "absolute",
                                    bottom: "-4px",
                                    left: 0,
                                    width: "100%",
                                    height: "2px",
                                    background: `linear-gradient(90deg, ${theme.palette.primary.main} 0%, transparent 100%)`,
                                }
                            }}
                        >
                            ArthGyan                     </Box>{" "}
                        Different
                    </Typography>





                </Box>

                {/* CARDS */}
                <Box
                    sx={{
                        display: "grid",
                        gridTemplateColumns: {
                            xs: "1fr",
                            sm: "1fr 1fr",
                            md: "1fr 1fr 1fr",
                        },
                        gap: { xs: 2.5, md: 3 },
                    }}
                >
                    {articles.map((item, index) => (
                        <Card
                            key={index}
                            elevation={0}
                            sx={{
                                borderRadius: "18px",
                                backgroundColor: "#ffffff",
                                border: "1px solid #e6edf5",
                                boxShadow: "0px 10px 30px rgba(0,0,0,0.05)",
                                transition: "all 0.35s ease",
                                overflow: "hidden",
                                position: "relative",
                                cursor: "pointer",

                                "&:hover": {
                                    transform: "scale(1.04)",
                                    boxShadow: `0 20px 50px ${theme.palette.primary.main}25`,
                                },

                                "&::before": {
                                    content: '""',
                                    position: "absolute",
                                    inset: 0,
                                    borderRadius: "18px",
                                    padding: "1.5px",
                                    background: `linear-gradient(135deg, ${theme.palette.primary.main}, transparent 70%)`,
                                    WebkitMask:
                                        "linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)",
                                    WebkitMaskComposite: "xor",
                                    maskComposite: "exclude",
                                    opacity: 0,
                                    transition: "opacity 0.35s ease",
                                },

                                "&:hover::before": {
                                    opacity: 1,
                                },
                            }}
                        >

                            <Box
                                component="img"
                                src={item.img}
                                alt={item.title}
                                sx={{
                                    width: "100%",
                                    height: { xs: 180, md: 200 },
                                    objectFit: "cover",
                                }}
                            />

                            <CardContent sx={{ p: 2.5 }}>
                                <Typography
                                    sx={{
                                        fontSize: 15,
                                        fontWeight: 600,
                                        mb: 0.5,
                                        color: theme.palette.text.primary,
                                    }}
                                >
                                    {item.title}
                                </Typography>

                                <Typography
                                    sx={{
                                        fontSize: "13px",
                                        color: theme.palette.text.secondary,
                                    }}
                                >
                                    {item.desc}
                                </Typography>
                            </CardContent>
                        </Card>
                    ))}
                </Box>

            </Container>
        </Box>
    );


};

export default WhyUs;
